// theme.ts
import { createTheme } from "@mui/material/styles";

export const getAppTheme = (isRTL: boolean) => {
  return createTheme({
    typography: {
      fontFamily: isRTL ? "Alexandria, Arial, sans-serif" : "Poppins, Arial, sans-serif",
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            color: "#373737",
          },
        },
      },
    },
  });
};
